export default __webpack_public_path__ + "static/mifuture-3-d7908b7cd9cb32dbe477010a45686811.png";